module.exports = {
  context: {
    breadcrumbs: [
      {
        url: '/about',
        title: 'About',
        isActive: true
      }
    ]
  }
}
